// @flow

import { OPERATION_BRANCH } from 'fc-model-sampling-points'

export default {
  [OPERATION_BRANCH]: null,
}
